import React from "react";
import { Link } from "react-router-dom";

const TG_HANDLE = "Slurp_Support_bot";
const TG_URL = `https://t.me/${TG_HANDLE}`;
const X_URL = "https://x.com/slurpdotgg";

function TgIcon() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true">
      <path d="M9.78 16.72 9.62 20.4c.51 0 .73-.22 1-.49l2.4-2.3 4.97 3.64c.91.5 1.56.24 1.81-.84l3.28-15.4h.01c.29-1.35-.49-1.88-1.38-1.55L1.43 9.92C.1 10.45.12 11.21 1.2 11.55l4.99 1.55 11.59-7.31c.55-.36 1.04-.16.64.2L9.78 16.72Z" />
    </svg>
  );
}

function XIcon() {
  return (
    <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor" aria-hidden="true">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231L18.244 2.25Zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77Z" />
    </svg>
  );
}

function CapabilityCard({ kicker, title, body }) {
  return (
    <div className="pm-dev__card">
      <div className="pm-dev__card-kicker">{kicker}</div>
      <div className="pm-dev__card-title">{title}</div>
      <div className="pm-dev__card-body">{body}</div>
    </div>
  );
}

export default function DevelopersPage() {
  return (
    <div className="pm-dev">
      <div className="pm-dev__hero">
        <div className="pm-dev__kicker">For Developers</div>
        <h1 className="pm-dev__title">Build on slurp.</h1>
        <p className="pm-dev__lead">
          The slurp SDK gives qualified developers the same launch and
          trade infrastructure that powers slurp.gg.
        </p>
      </div>

      <div className="pm-dev__cards">
        <CapabilityCard
          kicker="01"
          title="Launch"
          body={
            <>
              Spin up Solana token launches using the same flow slurp.gg
              runs in production. Multiple creator fee modes baked in.
            </>
          }
        />
        <CapabilityCard
          kicker="02"
          title="Trade"
          body={
            <>
              Quote and execute swaps against any pool. Standard Solana
              wallet integration. Designed for production reliability,
              not just happy-path demos.
            </>
          }
        />
        <CapabilityCard
          kicker="03"
          title="Earn"
          body={
            <>
              Track and claim creator earnings. Some fee modes are
              fully managed by slurp on your behalf, with no
              maintenance required from you.
            </>
          }
        />
      </div>

      <div className="pm-dev__notice">
        <div className="pm-dev__notice-pill">Early Access</div>
        <p>
          For the first month, we're hand-picking developers to onboard
          the SDK. Public release is planned for the near future. If
          you're building something cool, reach out and tell us about it.
        </p>
      </div>

      <div className="pm-dev__access">
        <div className="pm-dev__access-title">Apply for SDK access</div>
        <p className="pm-dev__access-body">
          Send us a quick note about what you're building. We typically
          respond within 24 hours.
        </p>
        <div className="pm-dev__access-ctas">
          <a
            className="pm-dev__cta pm-dev__cta--primary"
            href={TG_URL}
            target="_blank"
            rel="noreferrer"
          >
            <TgIcon />
            <span>@{TG_HANDLE} on Telegram</span>
          </a>
          <a
            className="pm-dev__cta"
            href={X_URL}
            target="_blank"
            rel="noreferrer"
          >
            <XIcon />
            <span>@slurpdotgg on X</span>
          </a>
        </div>
      </div>

      <div className="pm-dev__footnote">
        Want context first? Read the{" "}
        <Link to="/docs">protocol docs</Link>.
      </div>
    </div>
  );
}
